import { createTheme } from "@mui/material/styles";
import { styleOverrides } from "./shared";

export const defaultTheme = createTheme({
    typography: {
        fontFamily: `"Roboto", sans-serif`
    },
    palette: {
        secondary: {
            main: "#5E5959",
            dark: "#2c2d30",
            light: "#9c9c9c"
        },
        info: {
            main: "#9ECFE4",
            dark: "#074661ff",
            light: "#29b7f4ff"
        },
        background: {
            default: "#000000",
            paper: "#000000",
        },
        text: {
            primary: '#FFFFFF',
            secondary: "#858585"
        },
        custom: {
            border: "#85858580"
        },
        success: {
            light: "#c3f1ca",
            main: "#84f194ff"
        }
    },
    ...styleOverrides,       
});

defaultTheme.glow = `drop-shadow(1px 1px 0 ${defaultTheme.palette.background.default}) drop-shadow(-1px -1px 0 ${defaultTheme.palette.background.default})`